'use client';

import clsx from 'clsx';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import './LinkComponent.scss';

type LinkComponentProps = {
  href: string;
  children: React.ReactNode;
  className?: string;
  activeClassName?: string;
};

function LinkComponent({ href, children, className, activeClassName = 'underline-link-active' }: LinkComponentProps) {
  const pathname = usePathname();

  // Function to normalize URL by removing query params, hash, and trailing slash
  const normalizeUrl = (url: string) => {
    return url.split(/[?#]/)[0].replace(/\/$/, '');
  };

  const currentPath = normalizeUrl(pathname);
  const normalizedHref = normalizeUrl(href);
  const isActive = currentPath === normalizedHref;

  const classes = clsx(
    'underline-link',
    {
      [activeClassName]: isActive,
    },
    className,
  );

  return (
    <Link href={href} className={className}>
      <span className={classes}>{children}</span>
    </Link>
  );
}

export default LinkComponent;
